export default "__VITE_PUBLIC_ASSET__4fdc5827__"